import { render } from "./EventLayout.vue?vue&type=template&id=47b94ed2&scoped=true"
import script from "./EventLayout.vue?vue&type=script&lang=js"
export * from "./EventLayout.vue?vue&type=script&lang=js"

import "./EventLayout.vue?vue&type=style&index=0&id=47b94ed2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b94ed2"]])

export default __exports__